import Vue from "vue";

// Blocks Import

// Dependencies
import VueHeadful from "vue-headful"; 

// Section
import HeaderBlock from "@/components/blocks/header/header.block.vue"
import FooterBlock from "@/components/blocks/footer/footer.block.vue"

// Content
import Vector from "@/components/blocks/vector.vue"
import ImageBlock from "@/components/blocks/image/image.block.vue"
import InputBlock from "@/components/blocks/input/input.block.vue"
import LoadingBlock from "@/components/blocks/loading/loading.block.vue"
import TextBlock from "@/components/blocks/text/text.block.vue"

// Structure
import ButtonBlock from "@/components/blocks/button/button.block.vue"
import DocumentBlock from "@/components/blocks/document/document.block.vue"
import CardBlock from "@/components/blocks/card/card.block.vue"
import ProductBlock from "@/components/blocks/product/product.block.vue"
import SlideshowBlock from "@/components/blocks/slideshow-block/slideshow.block.vue"
import SideContentBlock from "@/components/blocks/sidecontent/sidecontent.block.vue"


// Blocks Key

// Dependencies
// Vue.component("markdown", VueMarkdown);
Vue.component('vue-headful', VueHeadful);

// Section
Vue.component("header-block", HeaderBlock);
Vue.component("footer-block", FooterBlock);

// Content
Vue.component("input-block", InputBlock);
Vue.component("image-block", ImageBlock);
Vue.component("vector", Vector);
Vue.component("loading-block", LoadingBlock);
Vue.component("text-block", TextBlock);

Vue.component("button-block", ButtonBlock);
Vue.component("document-block", DocumentBlock);
Vue.component("card-block", CardBlock);
Vue.component("product-block", ProductBlock);
Vue.component("slideshow-block", SlideshowBlock);
Vue.component("side-content-block", SideContentBlock);


// WEBPACK FOOTER //
// ./src/components/blocks/blocks.js